import React from "react";

import { ElementState } from "@creatomate/preview";

import { Trans } from "app/utils";

interface TitleProps {
  activeElement?: ElementState;
}

const Title: React.FC<TitleProps> = ({ activeElement }) => (
  <>
    {activeElement?.source?.type === "audio" ? (
      <h2><Trans>Edit Audio</Trans></h2>
    ) : (
      <h2><Trans>Select Audio</Trans></h2>
    )}
  </>
);

export default Title;
